<script>
  import { fade, fly } from "svelte/transition";
  export let closeModal;
  export let toggle;
</script>

<div class="modal-layout" in:fade out:fade>
  <div
    style="position:absolute; z-index:4; width: 100%; height: 100%;"
    on:click={closeModal}
  />
  <div
    class="modal-container"
    in:fly={{ y: 200, duration: 300 }}
    out:fly={{ y: 200, duration: 300 }}
  >
    <img class="check" src="images/success.png" alt="" />
    {#if toggle}
      <span>You have successfully submitted</span>
      <span>for endorsement!</span>
    {:else}
      <span>You have successfully applied</span>
      <span>to th3syndicate!</span>
    {/if}
    <div class="btn" on:click={closeModal}>
      <span class="btn-text"> GREAT! </span>
    </div>
    <img
      class="close"
      src="images/close.png"
      alt="close"
      on:click={closeModal}
    />
  </div>
</div>

<style>
  .close {
    width: 30px;
    top: 18px;
    right: 18px;
    padding: 5px;
    position: absolute;
    cursor: pointer;
  }
  .close:hover {
    filter: brightness(2);
  }

  .modal-layout {
    /* position: absolute; */
    background-color: rgba(0, 0, 0, 0.7);
    /* width: 100vw; */
    width: 100%;
    height: 100vh;
    position: fixed;
    display: grid;
    place-items: center;
    z-index: 3;
  }
  .modal-container {
    width: 100%;
    max-width: 440px;
    height: 381px;
    background: #111111;
    border: 1px solid #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 39px;
    position: relative;
    z-index: 5;
  }

  .check {
    margin-top: 88px;
    margin-bottom: 20px;
  }
  span {
    font-weight: 400;
    font-size: 18px;
    text-align: center;
    margin: 5px 0;
  }
  .btn {
    width: 168px;
    height: 50px;
    display: grid;
    place-items: center;
    background: #333333;
    border: 1px solid #ffffff;
    position: absolute;
    bottom: 40px;
    cursor: pointer;
  }
  .btn-text {
    font-weight: 600;
    font-size: 16px;
    letter-spacing: 0.1em;
  }
  .btn:hover {
    background-color: white;
  }
  .btn:hover .btn-text {
    color: black;
  }
  .close {
    width: 30px;
    top: 18px;
    right: 18px;
    padding: 5px;
    position: absolute;
    cursor: pointer;
  }
  .close:hover {
    filter: brightness(2);
  }

  @media (max-width: 440px) {
    .modal-container {
      width: 100%;
      position: absolute;
      bottom: 0;
    }
  }
</style>
